import { __awaiter, __decorate } from "tslib";
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ComponentService } from './component.service';
import { DepositOriginModalComponent } from '../pages/deposit-origin-modal';
import { depositOriginState, depositOriginStateForCode } from './deposit-origin';
/**
 * Opens the "Origin of funds" window of the deposit trigger over the page the user is on, in the
 * wallet and on the exchange alike: before an action on the funds, when the API refuses one with a
 * deposit-limit code, and after login.
 */
let DepositOriginService = class DepositOriginService {
    constructor(auth, compService) {
        this.auth = auth;
        this.compService = compService;
        // a gate is reading user/data: a second click meanwhile is dropped
        this.inFlight = false;
    }
    /**
     * Before buying, selling, converting, buying a basket or withdrawing. Nothing owed in the cached
     * user lets the action go without a request; a requirement that came up since is caught by the
     * API's refusal (openForCode). A cached requirement is read fresh from user/data, so a statement
     * sent or a proof accepted in this session lets the action through. onClear continues the action
     * when the window resolves the last requirement. Returns true when the caller stops: the window
     * opened, or another gate is still reading.
     */
    gate(onClear) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.inFlight) {
                return true;
            }
            if (depositOriginState(this.cachedUser()) === null) {
                return false;
            }
            this.inFlight = true;
            try {
                yield this.auth.fetchUser();
            }
            finally {
                this.inFlight = false;
            }
            const state = depositOriginState(this.cachedUser());
            if (state === null) {
                return false;
            }
            this.open(state, onClear);
            return true;
        });
    }
    /**
     * The API refused an action with DEPOSIT_WEEKLY_LIMIT_EXCEEDED or DEPOSIT_WEEKLY_LIMIT_L2_EXCEEDED.
     * onClear continues the refused action when the window resolves the last requirement.
     */
    openForCode(code, onClear) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.auth.fetchUser();
            this.open(depositOriginStateForCode(code, this.cachedUser()), onClear);
        });
    }
    open(state, onClear) {
        this.compService.openModal(DepositOriginModalComponent, { state, onClear });
    }
    cachedUser() {
        return JSON.parse(localStorage.getItem('user'));
    }
};
DepositOriginService.ctorParameters = () => [
    { type: AuthService },
    { type: ComponentService }
];
DepositOriginService = __decorate([
    Injectable()
], DepositOriginService);
export { DepositOriginService };
